<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-report|@@manageReport">Gestion des rapports</span>
    </div>
  </div>
  <form [formGroup]="reportForm">
    <div class="row mb-0">
      <div class="col-12 report-form">
        <span class="column-title" i18n="parameters-report|@@general">Général</span>
        <div class="container">
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@prefixReportName">Préfixe pour le nom des rapports</span>
            </div>
            <div class="col-5">
              <input type="text" placeholder="OL-" formControlName="prefix">
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@typeOfDefaultReport">Type de rapport par défault</span>
            </div>
            <div class="col-5">
              <ng-select [items]="typeValue" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="typeSelected"
                [ngModelOptions]="{standalone: true}" [virtualScroll]='true' (change)="handlerChange($event)"
                [searchable]='false' notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@typeOfDefaultCost">Type de chiffrage par défault</span>
            </div>
            <div class="col-5">
              <ng-select [items]="costValue" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="costSelected"
                [ngModelOptions]="{standalone: true}" [virtualScroll]='true' (change)="handlerChange($event)"
                [searchable]='false' notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@actionDefaultButton">Bouton action par défault</span>
            </div>
            <div class="col-5">
              <ng-select [items]="buttonValue" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="buttonSelected"
                [ngModelOptions]="{standalone: true}" [virtualScroll]='true' (change)="handlerChange($event)"
                [searchable]='false' notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@defaultVehicleModel">Patron de vehicule par
                défault</span>
            </div>
            <div class="col-5">
              <ng-select [items]="svgValue" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="svgSelected"
                [ngModelOptions]="{standalone: true}" [virtualScroll]='true' (change)="handlerChange($event)"
                [searchable]='false' notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@defaultTurnSens">Sens d'inspection du vehicule</span>
            </div>
            <div class="col-5">
              <ng-select [items]="sensValue" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="sensSelected"
                [ngModelOptions]="{standalone: true}" [virtualScroll]='true' (change)="handlerChange($event)"
                [searchable]='false' notFoundText="---" [clearable]='false' placeholder='---'>
              </ng-select>
            </div>
          </div>
          <div class="row generalrows">
            <div class="col-5 center">
              <span class="span-txt" i18n="parameters-report|@@defaultVehicleModelColors">Couleurs du Patron
                défault</span>
            </div>
            <div class="col-5">
              <ng-select [items]="svgColorsValue" [bindLabel]="'value'" [bindValue]="'key'"
                [(ngModel)]="svgColorSelected" [ngModelOptions]="{standalone: true}" [virtualScroll]='true'
                (change)="handlerChange($event)" [searchable]='false' notFoundText="---" [clearable]='false'
                placeholder='---'>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-0 mb-5">
      <div class="col-12">
        <div class="table-option-toggle">
          <div class="conatainer">
            <div class="row m-0 center-toggle">
              <div class="col-9">
                <span class="column-title" i18n="table-options-toggle|@@option">Option</span>
              </div>
              <div class="col-3">
                <span class="column-title" i18n="table-options-toggle|@@active">Activé</span>
              </div>
            </div>
            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@Automaticallyaddolddamage">Ajouter automatiquement les anciens
                  dommages</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="oldDamages" [value]="report.oldDamages === undefined ? true : report.oldDamages" ></app-generic-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="row">
      <div class="col-12 ">
        <span class="column-title" i18n="parameters-report|@@StateOfPlay">Etat des lieux</span>

        <div class="table-option-toggle">
          <div class="conatainer">
            <div class="row m-0 center-toggle">
              <div class="col-9">
                <span class="column-title" i18n="table-options-toggle|@@option">Option</span>
              </div>
              <div class="col-3">
                <span class="column-title" i18n="table-options-toggle|@@active">Activé</span>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@showCost">Afficher le prix de réparation sur le pdf</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="stateShowCost" [value]="report.state.showCost === undefined ? true : report.state.showCost" ></app-generic-toggle>
                </div>
              </div>
            </div>


            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@showRepairType">Afficher le type de réparation sur le pdf</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="stateShowSeverity" [value]="report.state.showSeverity === undefined ? true : report.state.showSeverity" ></app-generic-toggle>
                </div>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@croppImages">Zoom sur les dommages dans le pdf</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="stateCroppImages" [value]="report.state.croppImages === undefined ? false : report.state.croppImages" ></app-generic-toggle>
                </div>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@selectPicture">Photos présélectionnées</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="statePicturesPreSelected" [value]="report.state.picturesPreSelected === undefined ? true : report.state.picturesPreSelected" ></app-generic-toggle>
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@signatory">Signataire</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="stateSignatory" [value]="report.state.signatory === undefined ? true : report.state.signatory" ></app-generic-toggle>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>


    <div class="row">
      <div class="col-12 mt-5">
        <span class="column-title" i18n="parameters-report|@@simpleReport">Rapport simple</span>

        <div class="table-option-toggle">
          <div class="conatainer">
            <div class="row m-0 center-toggle">
              <div class="col-9">
                <span class="column-title" i18n="table-options-toggle|@@option">Option</span>
              </div>
              <div class="col-3">
                <span class="column-title" i18n="table-options-toggle|@@active">Activé</span>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@showCost">Afficher le prix de réparation sur le pdf</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="simpleShowCost" [value]="report.simple.showCost === undefined ? true : report.simple.showCost" ></app-generic-toggle>
                </div>
              </div>
            </div>

            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@showCost">Afficher le type de réparation sur le pdf</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="simpleShowSeverity" [value]="report.simple.showSeverity === undefined ? true : report.simple.showSeverity" ></app-generic-toggle>
                </div>
              </div>
            </div>



            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@croppImages">Zoom sur les dommages dans le pdf</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="simpleCroppImages" [value]="report.simple.croppImages === undefined ? false : report.simple.croppImages" ></app-generic-toggle>
                </div>
              </div>
            </div>



            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@selectPicture">Photos présélectionnées</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="simplePicturesPreSelected" [value]="report.simple.picturesPreSelected === undefined ? true : report.simple.picturesPreSelected" ></app-generic-toggle>
                </div>
              </div>
            </div>
            <div class="row m-0">
              <div class="col-9 center-toggle">
                <span i18n="parameters-report|@@signatory">Signataire</span>
              </div>
              <div class="col-3">
                <div class="parameters-toggle ">
                  <app-generic-toggle formControlName="simpleSignatory" [value]="report.simple.signatory === undefined ? true : report.simple.signatory" ></app-generic-toggle>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-reports/parameters-reports.component.html